<template>
  <div>
    <v-container class="content-wrapper" fluid id="equipment-tab">
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12">
          <h2 class="black--text font-weight-bold">
            Edit Equipment
          </h2>
        </v-col>
      </v-row>

      <!-- Tabs for edit equipment -->
      <v-row justify="center" align="center">
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <!-- Redirect to Equipment with Updates Saved -->
            <v-row align="center" class="mb-5">
              <v-col cols="12" md="auto">
                <v-btn
                  depressed
                  rounded
                  medium
                  color="primary200"
                  class="white--text font-weight-bold"
                  @click="back"
                >
                  <v-icon color="black" small class="mr-2">
                    mdi-arrow-left
                  </v-icon>
                  Back to your Equipment
                </v-btn>
              </v-col>
              <v-col cols="12" md="auto" v-if="savedChanges">
                <span class="text-bold">
                  Your changes have been saved.
                </span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" md="6" class="justify-end d-flex pt-5">
                <v-btn-toggle v-model="publicStatus" rounded mandatory>
                  <v-tooltip bottom color="neutral">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" value="PUBLIC" @click="publishEquipment">
                        {{ $t('public') }}
                        <v-icon class="pl-2">mdi-information-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('tooltip-public') }}</span>
                  </v-tooltip>
                  <v-tooltip bottom color="neutral">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" value="PRIVATE" @click="unpublishEquipment">
                        {{ $t('private') }}
                        <v-icon class="pl-2">mdi-information-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('tooltip-private') }}</span>
                  </v-tooltip>
                </v-btn-toggle>
              </v-col>
            </v-row>

            <v-tabs v-model="tab" show-arrows active-class="primary200--text">
              <v-tabs-slider color="primary200"></v-tabs-slider>
              <v-tab>{{ $t('basic') }}</v-tab>
              <v-tab>{{ $t('detailed') }}</v-tab>
              <v-tab>{{ $t('classification') }}</v-tab>
              <v-tab>{{ $t('contact') }}</v-tab>
              <v-tab>{{ $t('management') }}</v-tab>
              <v-tab>{{ $t('pricing') }}</v-tab>
              <v-tab>{{ $t('additional-information') }}</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item :value="0">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <EquipmentBasicInfo
                      :edit="true"
                      :published="isPublished"
                      @updatedChanges="handleUpdatedChanges"
                      @tab="changeTab"
                      @status="handleStatus"
                    ></EquipmentBasicInfo>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :value="1">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <EquipmentDetails
                      :edit="true"
                      :published="isPublished"
                      @tab="changeTab"
                      @updatedChanges="handleUpdatedChanges"
                      @status="handleStatus"
                    ></EquipmentDetails>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :value="2">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <EquipmentClassificationInfo
                      :edit="true"
                      :published="isPublished"
                      @tab="changeTab"
                      @updatedChanges="handleUpdatedChanges"
                      @status="handleStatus"
                    ></EquipmentClassificationInfo>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :value="3">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <EquipmentContactInfo
                      :edit="true"
                      :published="isPublished"
                      @tab="changeTab"
                      @updatedChanges="handleUpdatedChanges"
                      @status="handleStatus"
                    ></EquipmentContactInfo>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :value="4">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <EquipmentManagementInfo
                      :edit="true"
                      :published="isPublished"
                      @tab="changeTab"
                      @updatedChanges="handleUpdatedChanges"
                      @status="handleStatus"
                    ></EquipmentManagementInfo>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :value="5">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <EquipmentPricingInfo
                      :edit="true"
                      :published="isPublished"
                      @tab="changeTab"
                      @updatedChanges="handleUpdatedChanges"
                      @status="handleStatus"
                    ></EquipmentPricingInfo>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :value="6">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <EquipmentAdditionalInfo
                      :edit="true"
                      :published="isPublished"
                      @tab="changeTab"
                      @updatedChanges="handleUpdatedChanges"
                      @status="handleStatus"
                    ></EquipmentAdditionalInfo>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import EquipmentAdditionalInfo from '../add-equipment/EquipmentAdditionalInfo.vue';
import EquipmentBasicInfo from '../add-equipment/EquipmentBasicInfo.vue';
import EquipmentClassificationInfo from '../add-equipment/EquipmentClassificationInfo.vue';
import EquipmentContactInfo from '../add-equipment/EquipmentContactInfo.vue';
import EquipmentDetails from '../add-equipment/EquipmentDetails.vue';
import EquipmentManagementInfo from '../add-equipment/EquipmentManagementInfo.vue';
import EquipmentPricingInfo from '../add-equipment/EquipmentPricingInfo.vue';

export default {
  name: 'EditEquipment',
  components: {
    EquipmentBasicInfo,
    EquipmentDetails,
    EquipmentClassificationInfo,
    EquipmentContactInfo,
    EquipmentManagementInfo,
    EquipmentPricingInfo,
    EquipmentAdditionalInfo,
  },
  data: () => ({
    tab: null,
    totalTabs: 7,
    savedChanges: false,
    publicStatus: '',
  }),
  created() {
    this.publicStatus = this.$route.params.publicStatus;
  },
  computed: {
    isPublished() {
      return this.publicStatus === 'PUBLIC';
    },
  },
  methods: {
    changeTab(childTab) {
      this.tab = childTab;
    },
    handleUpdatedChanges(update) {
      this.savedChanges = update;
    },
    publishEquipment() {
      this.publicStatus = 'PUBLIC';
    },
    unpublishEquipment() {
      this.publicStatus = 'PRIVATE';
    },
    handleStatus(data) {
      this.publicStatus = data ? 'PUBLIC' : 'PRIVATE';
    },
    back() {
      if (this.$route.query.fromTable && this.$store.getters.roles === 'super-admin') {
        const fromTable = this.$route.query;
        this.$router.push({
          name: 'Equipment',
          query: fromTable,
        });
      } else if (this.$route.query.fromTable && this.$store.getters.roles === 'provider') {
        const fromTable = this.$route.query;
        this.$router.push({
          name: 'Equipment',
          query: fromTable,
        });
      }
    },
  },
};
</script>
